module.exports = "<svg id=cd5b880d-7ba2-4063-96d1-06b944e3dd12 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Printing</title><path d=M20.4,10.28h-.91a8.34,8.34,0,1,0-1.13,6.22.5.5,0,0,0-.84-.54,7.35,7.35,0,1,1,.93-5.69l-.72,0a.6.6,0,0,0-.6.62.8.8,0,0,0,.09.36c.13.25,1.21,2.28,1.29,2.41a.6.6,0,0,0,1,0c0-.05,1.36-2.36,1.41-2.43a.7.7,0,0,0,.08-.33A.58.58,0,0,0,20.4,10.28Z /><path d=M11.08,6a.5.5,0,0,0-.5.5v6.22a.5.5,0,0,0,.5.5H15a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H11.58V6.52A.5.5,0,0,0,11.08,6Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/printing.svg
// module id = 168
// module chunks = 0